import Card from '../../components/ui/Card'
import Badge from '../../components/ui/Badge'
import { formatCurrency, formatNumber } from '../../lib/format'

const healthVariants = {
  healthy: 'badge-healthy',
  warning: 'badge-warning',
  critical: 'badge-critical',
}

function ProductOverviewCard({ product }) {
  const health = product.health || 'healthy'
  const healthClass = healthVariants[health] || healthVariants.healthy

  return (
    <Card className="product-card">
      <Card.Header className="product-card-header">
        <div>
          <Card.Title>{product.name}</Card.Title>
          <div className="text-sm text-muted">Status</div>
        </div>
        <Badge className={product.status === 'active' ? 'badge-active' : 'badge-planning'}>
          {product.status}
        </Badge>
      </Card.Header>
      <Card.Body>
        <div className="product-metrics">
          <div>
            <div className="text-sm text-muted">Revenue</div>
            <div className="text-lg font-medium">{formatCurrency(product.revenue || 0)}</div>
          </div>
          <div>
            <div className="text-sm text-muted">Users</div>
            <div className="text-lg font-medium">{formatNumber(product.users || 0)}</div>
          </div>
          <div>
            <div className="text-sm text-muted">Health</div>
            <div className={`badge ${healthClass}`}>{health}</div>
          </div>
        </div>

        <div className="product-links">
          {product.repo_url && <a href={product.repo_url} target="_blank" rel="noreferrer">Repo</a>}
          {product.docs_url && <a href={product.docs_url} target="_blank" rel="noreferrer">Docs</a>}
          {product.dashboard_url && <a href={product.dashboard_url} target="_blank" rel="noreferrer">Dashboard</a>}
        </div>
      </Card.Body>
    </Card>
  )
}

export default ProductOverviewCard
